import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation, Pagination } from "swiper/modules";
import serviceA from "../../Assets/LWU/service-a.png";
import serviceB from "../../Assets/LWU/service-b.png";
import serviceC from "../../Assets/LWU/service-c.png";
import serviceD from "../../Assets/LWU/service-d.png";
import serviceE from "../../Assets/LWU/service-e.png";
import serviceF from "../../Assets/LWU/service-f.png";
import serviceG from "../../Assets/LWU/service-g.png";
import serviceH from "../../Assets/LWU/service-h.png";
import serviceI from "../../Assets/LWU/service-i.png";
import serviceJ from "../../Assets/LWU/service-j.png";

const sliderData = [
  {
    title: "Dynamic & Strategic Pricing",
    imageUrl: serviceA,
  },
  {
    title: "Multi-Platform Listing & Visibility",
    imageUrl: serviceB,
  },
  {
    title: "Professional Photography & Videography",
    imageUrl: serviceC,
  },
  {
    title: "24/7 Guest Relations & Communication",
    imageUrl: serviceD,
  },
  {
    title: "5-Star Cleaning & Hotel-Grade Linens",
    imageUrl: serviceE,
  },
  {
    title: "Partnership with 365 Maintenance for Upkeep",
    imageUrl: serviceF,
  },
  {
    title: "Guest Vetting & Security",
    imageUrl: serviceG,
  },
  {
    title: "Legal Compliance & DTCM Permitting",
    imageUrl: serviceH,
  },
  {
    title: "Monthly Financial Reporting",
    imageUrl: serviceI,
  },
  {
    title: "Access to 365 Concierge Services for Guests",
    imageUrl: serviceJ,
  },
];

export default function CardsSlider() {
  return (
    <>
      <style>{`
        .swiper-slide {
          transition: transform 0.3s ease-in-out;
        }
        
        .swiper-pagination-bullet {
          width: 10px;
          height: 2px;
          border-radius: 2px;
          background-color: #fff;
          opacity: 0.5;
          transition: opacity 0.3s, width 0.3s;
        }
        .swiper-pagination-bullet-active {
          width: 40px;
        }
      `}</style>

      <div className="relative flex flex-col items-center">
        <div className="absolute"></div>

        <div className="relative w-full">
          <Swiper
            modules={[Navigation, Pagination]}
            grabCursor={true}
            loop={true}
            slidesPerView={3}
            spaceBetween={20}
            centeredSlides={false}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 80,
              modifier: 2,
              slideShadows: false,
            }}
            breakpoints={{
              "@0.00": {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              "@0.75": {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              "@1.00": {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              "@1.50": {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            pagination={{
              el: ".swiper-pagination-custom",
              clickable: true,
            }}
            navigation={{
              nextEl: ".swiper-button-next-custom",
              prevEl: ".swiper-button-prev-custom",
            }}
            className="card_slider w-full"
          >
            {sliderData.map((slide, index) => (
              <SwiperSlide key={index} className="w-[280px] md:w-[400px]">
                <div className="relative w-full h-[380px] rounded-2xl overflow-hidden">
                  <img
                    src={slide.imageUrl}
                    alt={slide.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://placehold.co/400x500/e2e8f0/4a5568?text=Image+Not+Found";
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 p-6">
                    <h3 className="text-white text-xl ">{slide.title}</h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="relative mt-12 flex items-center justify-center md:gap-8 gap-2 z-10 w-full">
          <button className="swiper-button-prev-custom min-w-12 min-h-12 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              />
            </svg>
          </button>
          <button className="swiper-button-next-custom min-w-12 min-h-12 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
          <div className="swiper-pagination-custom flex items-center gap-2"></div>
        </div>
      </div>
    </>
  );
}
